import i18n from "./i18n";

type TranslateOptions = Record<string, unknown>;

export function t(key: string, options?: TranslateOptions): string {
    return (i18n.t as any)(key, options);
}
